import React, {useEffect, useState } from "react";
import { createDeal, updateDeal, getDealStages } from "../api";

export default function AddDealModal({
  lead,
  deal,
  users,
  onClose,
  onSuccess,
}) {
    const [loading, setLoading] = useState(false);
    const [dealStages, setDealStages] = useState([]);

const [form, setForm] = useState({
  deal_name: deal?.deal_name || lead?.name || "",
  project_name: deal?.project_name || lead?.product_interest || "",
  deal_value: deal?.deal_value || lead?.budget_cr || "",
  stage: deal?.stage || "Meeting Done",
  priority: deal?.priority || "Warm",
  assigned_to: deal?.assigned_to || lead?.assigned_to || "",
  description: deal?.description || "",
  meeting_date: deal?.meeting_date || "",
  site_visit_date: deal?.site_visit_date || "",
});

useEffect(() => {

loadStages();

}, []);

async function loadStages(){

const res = await getDealStages();

setDealStages(res.data);

}
  

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };
    const handleSave = async () => {
  try {

    setLoading(true);
    
        if (
form.stage === "Meeting Done" &&
!form.meeting_date
){
alert("Please select Meeting Done Date");
return;
}

if (
form.stage === "Site Visit" &&
!form.site_visit_date
){
alert("Please select Site Visit Date");
return;
}

    const payload = {
      lead_id: lead?.id || deal?.lead_id,
      deal_name: form.deal_name,
      project_name: form.project_name,
      deal_value: form.deal_value,
      stage: form.stage,
      assigned_to: form.assigned_to,
      priority: form.priority,
      description: form.description,
      meeting_date: form.meeting_date || null,
      site_visit_date: form.site_visit_date || null,
    };

    if (deal) {
      await updateDeal(deal.id, payload);
      alert("Deal Updated Successfully");
    } else {
      await createDeal(payload);
      alert("Deal Created Successfully");
    }

    onSuccess?.();
    onClose();

  } catch (err) {

    console.log(err);

    alert(err.response?.data?.error || "Something went wrong");

  } finally {

    setLoading(false);

  }
};

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,.45)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 99999,
      }}
    >
      <div
        style={{
          width: 650,
          background: "#fff",
          borderRadius: 12,
          padding: 24,
        }}
      >
        <h2>{deal ? "Edit Deal" : "Create New Deal"}</h2>

        <div
  style={{
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "16px",
  }}
>

  <div>
    <label>Deal Name</label>

    <input
      type="text"
      name="Client_name"
      value={form.deal_name}
      onChange={handleChange}
      placeholder="Enter deal name"
      style={{ width: "100%", padding: 10 }}
    />
  </div>

  <div>
    <label>Project</label>

    <select
  name="project_name"
  value={form.project_name}
  onChange={(e) => {
    const value = e.target.value;

    let dealValue = "";

    if (value === "Twin Lakes") dealValue = 4000000;
    if (value === "Araville") dealValue = 8500000;
    if (value === "Sway") dealValue = 15000000;

    setForm({
      ...form,
      project_name: value,
      deal_value: dealValue,
    });
  }}
  style={{
    width: "100%",
    padding: 10,
  }}
>
  <option value="">Select Project</option>
  <option value="Twin Lakes">Twin Lakes</option>
  <option value="Araville">Araville</option>
  <option value="Sway">Sway</option>
</select>
  </div>

  <div>
    <label>Deal Value</label>

    <input
  type="number"
  name="deal_value"
  value={form.deal_value}
  onChange={handleChange}
  placeholder="Deal Value"
  style={{
    width: "100%",
    padding: 10,
  }}
/>
  </div>

  <div>
  <label>Stage</label>

  <select
name="stage"
value={form.stage}
onChange={handleChange}
style={{ width: "100%", padding: 10 }}
>

{dealStages.map((stage) => (
  <option
    key={stage.id}
    value={stage.stored_value}
  >
    {stage.display_name}
  </option>
))}

</select>
</div>

    {form.stage === "Meeting Done" && (

<div>
<label>
  {dealStages.find(
    (stage) => stage.stored_value === "Meeting Done"
  )?.display_name || "Meeting Done"} Date *
</label>

<input
type="date"
name="meeting_date"
value={form.meeting_date}
onChange={handleChange}
style={{
width:"100%",
padding:10
}}
/>

</div>

)}

{form.stage === "Site Visit" && (

<div>
<label>
  {dealStages.find(
    (stage) => stage.stored_value === "Site Visit"
  )?.display_name || "Site Visit"} Date *
</label>

<input
type="date"
name="site_visit_date"
value={form.site_visit_date}
onChange={handleChange}
style={{
width:"100%",
padding:10
}}
/>

</div>

)}

  <div>
    <label>Priority</label>

    <select
      name="priority"
      value={form.priority}
      onChange={handleChange}
      style={{ width: "100%", padding: 10 }}
    >
      <option>Hot</option>
      <option>Warm</option>
      <option>Cold</option>
    </select>
  </div>

  <div>
    <label>Assigned To</label>

    <select
      name="assigned_to"
      value={form.assigned_to}
      onChange={handleChange}
      style={{ width: "100%", padding: 10 }}
    >
      <option value="">Select User</option>

      {users?.map((u) => (
        <option
          key={u.id}
          value={u.id}
        >
          {u.name}
        </option>
      ))}

    </select>
  </div>

</div>

<div
  style={{
    marginTop: 20,
  }}
>

<label>Description</label>

<textarea
  rows={4}
  name="description"
  value={form.description}
  onChange={handleChange}
  style={{
    width: "100%",
    padding: 12,
  }}
/>

</div>

<div
  style={{
    display: "flex",
    justifyContent: "flex-end",
    gap: 12,
    marginTop: 24,
  }}
>

<button
onClick={onClose}
style={{
padding:"10px 18px"
}}
>
Cancel
</button>

<button
onClick={handleSave}
disabled={loading}
style={{
padding:"10px 22px",
background:"#16a34a",
color:"#fff",
border:"none",
borderRadius:8,
cursor:"pointer"
}}
>
{loading
 ? "Saving..."
 : deal
 ? "Update Deal"
 : "Save Deal"}
</button>

</div>
    
     

      </div>
    </div>
  );
}